import { processHitsProducts } from '../../productSuggestions/services/algolia/processor';
import {
  HISTORY_IN_EMPTY_STATE_MAX_LENGTH,
  HISTORY_MAX_LENGTH,
} from '../components/Search/utils/searchHistory/constants';
import { getSearchHistory } from '../components/Search/utils/searchHistory/get';
import {
  GET_EMPTY_SEARCH_SUGGESTIONS_FAILED,
  GET_EMPTY_SEARCH_SUGGESTIONS_SUCCESS,
  REMOVE_ALL_SUGGESTIONS_HISTORY,
  UPDATE_SUGGESTIONS_HISTORY,
  type Action,
} from '../HeaderLeonidas.searchBar.actions';
import type {
  EmptySearchSuggestions,
  Suggestion,
} from '../interfaces/suggestions';
import { buildSuggestionsGroup } from '../utils/buildSuggestionsGroup';
import { formatSuggestion } from '../utils/formatSuggestion';

export default function reducer(
  state: EmptySearchSuggestions = {},
  action: Action,
): EmptySearchSuggestions {
  switch (action.type) {
    case GET_EMPTY_SEARCH_SUGGESTIONS_SUCCESS: {
      const { resultsQueries, staticSuggestions, lastSeenProducts } = action;
      const history = getSearchHistory(HISTORY_IN_EMPTY_STATE_MAX_LENGTH);

      return {
        ...state,
        histories: {
          items: history?.map(
            (query) =>
              formatSuggestion({
                name: query,
                termQuery: '',
                type: 'history',
              }) as Suggestion,
          ),
        },
        queries:
          resultsQueries.queries &&
          buildSuggestionsGroup({
            hits: resultsQueries.queries.hits,
            index: resultsQueries.queries.index,
            queryID: resultsQueries.queries.queryID,
            type: 'query',
          }),
        categories:
          resultsQueries.categories &&
          buildSuggestionsGroup({
            hits: resultsQueries.categories.hits,
            index: resultsQueries.categories.index,
            queryID: resultsQueries.categories.queryID,
            history: staticSuggestions ? history : undefined,
            type: 'category',
            staticSuggestions,
          }),
        brands:
          resultsQueries.brands &&
          buildSuggestionsGroup({
            hits: resultsQueries.brands.hits,
            index: resultsQueries.brands.index,
            queryID: resultsQueries.brands.queryID,
            history: staticSuggestions ? history : undefined,
            type: 'brand',
            staticSuggestions,
          }),
        topProducts: resultsQueries.products
          ? {
              items: processHitsProducts(resultsQueries.products.hits),
              queryDetails: {
                index: resultsQueries.products.index,
                queryID: resultsQueries.products.queryID,
              },
              type: lastSeenProducts ? 'history' : 'top',
            }
          : undefined,
        similarityProducts:
          lastSeenProducts && resultsQueries.similarityProducts
            ? {
                items: processHitsProducts(
                  resultsQueries.similarityProducts.hits,
                ),
                queryDetails: {
                  index: resultsQueries.similarityProducts.index,
                  queryID: resultsQueries.similarityProducts.queryID,
                },
                type: 'similarity',
              }
            : undefined,
      };
    }

    case GET_EMPTY_SEARCH_SUGGESTIONS_FAILED: {
      const history = getSearchHistory(HISTORY_MAX_LENGTH);

      return {
        ...state,
        histories: {
          items: history?.map(
            (query) =>
              formatSuggestion({
                name: query,
                termQuery: '',
                type: 'history',
              }) as Suggestion,
          ),
        },
      };
    }

    case UPDATE_SUGGESTIONS_HISTORY: {
      const { queries, categories, brands } = state;
      const hasEmptySearchSuggestions = !!queries || !!categories || !!brands;
      const history = getSearchHistory(
        hasEmptySearchSuggestions
          ? HISTORY_IN_EMPTY_STATE_MAX_LENGTH
          : HISTORY_MAX_LENGTH,
      );

      return {
        ...state,
        histories: {
          items: history.map(
            (query) =>
              formatSuggestion({
                name: query,
                termQuery: '',
                type: 'history',
              }) as Suggestion,
          ),
        },
      };
    }

    case REMOVE_ALL_SUGGESTIONS_HISTORY: {
      return { ...state, histories: { items: [] } };
    }

    default:
      return state;
  }
}
